

















import Vue from 'vue';

export default Vue.extend({
  name: 'PlansNavigation',

  computed: {
    exitRoute() {
      const destination = this.$route.query?.destination as string;
      if (destination) {
        return { path: destination };
      } else {
        return { name: 'campaigns' };
      }
    }
  },

  methods: {
    navigateToCampaignsDashboard() {
      this.$router.push({ name: 'campaigns' });
    }
  }
});
